import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-students-never-on-bus",
	templateUrl: "./students-never-on-bus.component.html",
	styleUrls: ["./students-never-on-bus.component.css"],
})
export class StudentsNeverOnBusComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private dialogService: DialogService
	) {}

	report = {
		StartDate: new Date(),
		SortByID: "FirstName",
		SortDirectionID: "ASC",
		SchoolID: 0,
		ImageLogo: "",
	};

	SchoolSelectShowAllText: string = "All Schools";
	NoScansOnly: boolean = true;

	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Bus",
			Desc: "Bus",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 487;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		var TwoWeeksAgo = new Date();
		TwoWeeksAgo.setDate(TwoWeeksAgo.getDate() - 14 - (TwoWeeksAgo.getDay() - 1));
		this.report.StartDate = TwoWeeksAgo;

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadLogolist();
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: NoScansOnly
		strParam += "," + (this.NoScansOnly == true ? 1 : 0) + "|NoScansOnly";

		//Parameter 3: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 4: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 5: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 6: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
